<template>
    <div class="form mobile-banker-form">
        <preloader v-show="loading"></preloader>
        <cards-form-v2-success
            :sended="sended"
            :sended-success="sendedSuccess"
            :is-delivery="isDelivery"
            :is-mobile="isMobile"
            :meeting-address="meeting.address"
            :date="meeting.date"
            :time="meeting.time"
            :email="email"
            :deliveryType="deliveryType"
            :office-address="officeAddress"
            :office-shedule="officeShedule"
            @sendStep="sendStep"
        />
        <cards-form-v2-error
            v-if="hasCard || isDuplicate"
            :has-card="hasCard"
            :is-duplicate="isDuplicate"
        />

        <div v-if="!sended && !hasCard && !isDuplicate" class="form__scope form__content-superwide" :class="{'form__scope-wp': !sended && currentStep === 1}">
            <div class="h2 _mb-24 text-align-center-mob" v-if="currentStep === 1">Закажите дебетовую карту</div>
            <div class="h2 _mb-24 text-align-center-mob" v-if="currentStep === 2">Заполните заявку</div>
            <div class="h2 _mb-24 text-align-center-mob" v-if="currentStep === 3">Заполните заявку</div>
            <div class="h2 _mb-24 text-align-center-mob" v-if="currentStep === 4">Заполните заявку</div>

            <div class="form__progress-step" v-show="currentStep === 1">
                <cards-form-v2-step1
                    :is-mobile="isMobile"
                    @setExtraData="setExtraData"
                    @sendStep="sendStep"
                />
            </div>

            <div class="form__progress-step" v-show="currentStep === 2">
                <cards-form-v2-step2
                    :phone="phone"
                    :productCode="productCode"
                    :birthdate="birthDate"
                    @sendStep="sendStep"
                    @setExtraData="setExtraData"
                    @closeForm="closeFormStep2($event)"
                />
            </div>
            <div class="form__progress-step" v-show="currentStep === 3">
                <cards-form-v2-step3
                    @sendStep="sendStep"
                />
            </div>
            <div class="form__progress-step" v-show="currentStep === 4">
                <cards-form-v2-step4
                    :lastName="lastName"
                    :firstName="firstName"
                    @sendStep="sendStep"
                />
            </div>
        </div>

        <!-- modals -->
        <d-modal
            v-cloak
            name="error-modal"
            :popup-title="errorTitle"
            size="small"
        >
            <p
                class="d-modal__text p1"
                v-html="errorText"
            />
        </d-modal>

        <d-modal
            v-cloak
            name="appointment_filled"
            popup-title="Нам жаль"
            size="small"
        >
            <p class="text text-gray">Выбранная дата уже занята. Выберите, пожалуйста, другую дату</p>
            <button @click.prevent="$modal.hide('appointment_filled')" class="button button_green">
                <span>Хорошо</span>
            </button>
            <br>
        </d-modal>

        <d-modal
            v-cloak
            name="agreement"
            popup-title="Согласие заявителя (далее – Согласие)"
            size="wide"
        >
            <p class="d-modal__text p1">
                <slot name="agreement"></slot>
            </p>
            <br>
        </d-modal>

        <!-- modals promo -->
        <d-modal
            v-cloak
            name="success"
            size="actions"
            mobile-full
        >
            <div>
                <div class="d-modal__img d-modal__img-done _mb-48"></div>
                <div class="h2 _mb-16 text-align-center">Готово!</div>
                <div class="p1 _mb-32 text-align-center">Промокод отправлен на указанный электронный адрес</div>
                <div class="button button_green button_width-max" @click="$modal.hide('success')">Закрыть</div>
            </div>
        </d-modal>

        <d-modal
            v-cloak
            name="error"
            size="actions"
            mobile-full
        >
            <div>
                <div class="d-modal__img d-modal__img-cancel _mb-48"></div>
                <div class="h2 _mb-16 text-align-center">Похоже, произошла ошибка</div>
                <div class="p1 _mb-32 text-align-center">Попробуйте повторить попытку позднее</div>
                <div class="button button_green button_width-max" @click="$modal.hide('error')">Закрыть</div>
            </div>
        </d-modal>
    </div>
</template>

<script>
import { scrollToElem } from "../../assets/js/utils"
import CardsFormV2Step1 from '../../components-manual/cards/CardsFormV2Step1.vue';
import CardsFormV2Step2 from '../../components-manual/cards/CardsFormV2Step2.vue';
import CardsFormV2Step3 from '../../components-manual/cards/CardsFormV2Step3.vue';
import CardsFormV2Step4 from '../../components-manual/cards/CardsFormV2Step4.vue';
import CardsFormV2Success from '../../components-manual/cards/CardsFormV2Success.vue';
import CardsFormV2Error from '../../components-manual/cards/CardsFormV2Error.vue';
import { ECARD_TYPE, debitCard, salaryCard } from '../../api/card';
import { waitPhoneCode } from "../../assets/js/handleOtpExpired";
import { EMBProductCode } from "../widgets/MeetingForm/const";

const EPropCardType = {
    DEBIT: 'debit',
    SALARY: 'salary',
};

export default {
    name: 'CardsFormV2',
    props: {
        cardType: {
            type: String,
            default: EPropCardType.DEBIT
        }
    },
    components: {
        CardsFormV2Step1,
        CardsFormV2Step2,
        CardsFormV2Step3,
        CardsFormV2Step4,
        CardsFormV2Success,
        CardsFormV2Error,
    },
    data() {
        return {
            loading: false,
            isMobile: false,
            isDelivery: false,
            isDuplicate: false,
            hasCard: false,
            sended: false,
            sendedSuccess: false,
            errorTitle: 'Ошибка',
            errorText: '',
            phone: '',
            deliveryType: '',
            officeAddress: '',
            officeShedule: '',
            birthDate: '',
            lastName: '',
            firstName: '',
            middleName: '',
            email: '',
            meeting: {
                region: '',
                city: '',
                office: '',
                address: '',
                date: '',
                time: '',
                d2dDelivery: false
            },

            passportSerial: '',
            passportNumber: '',
            passportIssueBy: '',
            passportIssueDate: '',
            passportCode: '',
            passportBirthPlace: '',
            registrationAddress: '',
            registrationDate: '',
            livingAddress: '',
            addressIsSame: true,

            firstNameLat: '',
            lastNameLat: '',
            codeWord: '',

            currentStep: 1,
            sessid: window.config.bitrix_sessid,
            formData: {
                data: {
                    type: null,
                    attributes: {}
                }
            }
        }
    },
    watch: {
        currentStep() {
            scrollToElem('card_order_form');
        }
    },
    methods: {
        deviceType() {
            this.isMobile = window.innerWidth <= 1000;
        },
        setExtraData(data) {
            if (this.currentStep === 1) {
                this.lastName = data.lastName;
                this.firstName = data.firstName;
                this.birthDate = data.birthDate;
            }
            if (this.currentStep === 2) {
                this.officeShedule = data.officeShedule;
                this.officeAddress = data.officeAddress;
                this.isDelivery = data.isDelivery;
                this.deliveryType = data.deliveryType;
                this.email = data.email;
                this.meeting = data.meeting;
            }
        },
        async sendStep(data) {
            this.loading = true;

            this.phone = this.currentStep === 1 ? data.data.attributes.phone : this.formData.data.attributes.phone;

            this.formData.data.attributes = Object.assign(this.formData.data.attributes, data.data.attributes);
            this.formData.data.attributes.phone = this.phone;

            const dataType = this.cardType === EPropCardType.DEBIT ? ECARD_TYPE.CARD_DEBIT : ECARD_TYPE.CARD_SALARY;

            await waitPhoneCode(dataType, this.formData.data.attributes.phone).catch((e) => {
                this.loading = false;
                throw e;
            });
            
            const fetchData = () => dataType === ECARD_TYPE.CARD_DEBIT ?
                debitCard(this.formData.data.attributes, this.currentStep) : 
                salaryCard(this.formData.data.attributes, this.currentStep);

            fetchData()
                .then(res => {
                    res = res.data.data;

                    if (this.currentStep === 1) {
                        // если у клиента уже есть карта
                        if (res.attributes.pr > 0) {
                            this.hasCard = true;
                            return;
                        }
                        if (res.attributes.pr === -1) {
                            this.hasDuplicate = true;
                            return;
                        }
                        if (res.attributes.pr === 0) {
                            if (this.cardType === EPropCardType.DEBIT) {
                                if (window.dmpkitdl) window.dmpkitdl.push({event: 'card-debet-1draft-form-send'});
                            }
                            if (this.cardType === EPropCardType.SALARY) {
                                if (window.dmpkitdl) window.dmpkitdl.push({event: 'card-salary-1draft-form-send'});
                            }
                            this.currentStep++;
                            return;
                        }
                    } else {
                        this.currentStep++;

                        if (res.attributes.final === true) {
                            this.sended = true;
                            this.sendedSuccess = true;

                            if (this.cardType === EPropCardType.DEBIT) {
                                if (window.dmpkitdl) window.dmpkitdl.push({event: 'card-debet-lead-fos-send'});
                            }
                            if (this.cardType === EPropCardType.SALARY) {
                                if (window.dmpkitdl) window.dmpkitdl.push({event: 'card-salary-lead-fos-send'});
                            }
                        }
                    }
                })
                .catch(res => {
                    if ( ['Указан не верный телефон подтверждения', 'Смс-код не подтверждён', 'Ошибка сохранения'].includes(res.response?.data.errors[0].details) ) {
                        this.errorTitle = 'Ошибка';
                        this.errorText = res.response.data.errors[0].details;
                    }
                    if (res.response?.status === 500 || res.response?.data.errors[0].status === 500) {
                        this.errorTitle = 'Ошибка';
                        this.errorText = 'Повторите попытку позже.';
                    }
                    if (res.response?.data.errors[0].status === 422 && res.response.data.errors[0].title === 'Некорректный шаг сохранения.') {
                        this.errorTitle = 'Уведомление';
                        this.errorText = 'Ваша заявка отправлена в банк. Ожидайте';
                    }
                    if (res.response?.data.errors[0].status === 422 && res.response.data.errors[0].title === 'Ваша заявка находится в обработке другого бизнес-процесса.') {
                        this.errorTitle = 'Ошибка';
                        this.errorText = 'Ваша заявка находится в обработке другого бизнес-процесса';
                    }
                    if (res.response?.data.errors[0].status === 429 && res.response.data.errors[0].details.code === 1) {
                        this.hasCard = true;
                        return;
                    }
                    if (res.response?.data.errors[0].status === 429 && res.response.data.errors[0].details.code === 2) {
                        this.isDuplicate = true;
                        return;
                    }

                    this.$modal.show('error-modal');
                })
                .finally(() => {
                    this.loading = false;
                    scrollToElem('card_order_form');
                })
        },
    },
    computed: {
        productCode() {
            let res = EMBProductCode.DEBIT_CARD;
            switch(this.cardType) {
                case EPropCardType.DEBIT: res = EMBProductCode.DEBIT_CARD; break;
                case EPropCardType.SALARY: res = EMBProductCode.SALARY_CARD; break;
                default: break;
            }
            return res;
        },
    },
    created() {
        this.deviceType();
        window.addEventListener('resize', this.deviceType, false);
    },
}
</script>
